var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox align-center",staticStyle:{"cursor":"pointer"},on:{"click":_vm.updateCheck}},[_c('v-icon',{attrs:{"color":_vm.color,"size":_vm.size}},[_vm._v(" mdi-"+_vm._s(_vm.icon)+" ")]),_c('span',{staticClass:"ml-4"},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }